import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";

import { FaUsers, FaCheckCircle, FaChartLine } from "react-icons/fa";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, LineChart, Line, CartesianGrid } from "recharts";

const leadsData = [
  { month: "Jan", leads: 100 },
  { month: "Feb", leads: 200 },
  { month: "Mar", leads: 300 },
  { month: "Apr", leads: 250 },
  { month: "May", leads: 400 },
  { month: "Jun", leads: 350 },
];

const conversionData = [
  { month: "Jan", rate: 20 },
  { month: "Feb", rate: 25 },
  { month: "Mar", rate: 30 },
  { month: "Apr", rate: 28 },
  { month: "May", rate: 35 },
  { month: "Jun", rate: 37 },
];

const Dashboard = () => {

  return (
    <div className="flex ">
      <Sidebar />
      <div className="flex-1 ml-16">
        <Navbar />
        <div className="p-6 mt-16">
          <h2 className="text-2xl font-bold mb-6">Dashboard Overview</h2>
          <div className="grid grid-cols-3 gap-6">
            <Card icon={<FaUsers />} title="Total Leads" value="1,200" />
            <Card icon={<FaCheckCircle />} title="Converted Leads" value="450" />
            <Card icon={<FaChartLine />} title="Conversion Rate" value="37.5%" />
          </div>
          
        {/* Charts Section */}
<div className="grid grid-cols-2 gap-6 mt-8">
  {/* Leads Chart */}
  <div className="bg-white p-6 rounded-lg shadow-md">
    <h3 className="text-lg font-semibold mb-4">Leads Over Time</h3>
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={leadsData}>
        <XAxis dataKey="month" />
        <YAxis />
        <Tooltip />
        <Bar dataKey="leads" fill="#3182CE" />
      </BarChart>
    </ResponsiveContainer>
  </div>

  {/* Conversion Rate Chart */}
  <div className="bg-white p-6 rounded-lg shadow-md">
    <h3 className="text-lg font-semibold mb-4">Conversion Rate Over Time</h3>
    <ResponsiveContainer width="100%" height={300}>
      <LineChart data={conversionData}>
        <XAxis dataKey="month" />
        <YAxis />
        <Tooltip />
        <CartesianGrid strokeDasharray="3 3" />
        <Line type="monotone" dataKey="rate" stroke="#E53E3E" strokeWidth={2} />
      </LineChart>
    </ResponsiveContainer>
  </div>
</div>

        </div>
      </div>
    </div>
  );
};

const Card = ({ icon, title, value }) => (
  <div className="bg-white p-6 rounded-lg shadow-md flex items-center space-x-4">
    <div className="text-blue-500 text-3xl">{icon}</div>
    <div>
      <h4 className="text-lg font-semibold">{title}</h4>
      <p className="text-xl font-bold">{value}</p>
    </div>
  </div>
);

export default Dashboard;
